import { Tooltip } from "@mantine/core"
import { IconInfoCircle } from "@tabler/icons-react"
import { primaryColor } from "../../../constants/theme"

export const InformationIconWithText = ({message, testId}: {message: string, testId: string}) => {
    return (
        <Tooltip data-testid={testId} events={{ hover: true, focus: true, touch: false }} label={message} withArrow>
            <IconInfoCircle color={primaryColor} size={25} style={{ cursor: 'help' }} />
        </Tooltip>
    )
}